var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgHeatExchanger = function SvgHeatExchanger(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 32V28.5H3.5V32H3C1.89543 32 1 32.8954 1 34V46C1 47.1046 1.89543 48 3 48H6C7.10457 48 8 47.1046 8 46V34C8 32.8954 7.10457 32 6 32H5.5ZM3.5 34H3L3 46H6V34H5.5H3.5Z",
    fill: "#4281AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 27C1 26.4477 1.44772 26 2 26H7C7.55229 26 8 26.4477 8 27C8 27.5523 7.55229 28 7 28H2C1.44772 28 1 27.5523 1 27Z",
    fill: "#4281AF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.3347 47H73V35H76V47H75.3347V46.9984H73.3347V47ZM73.3347 49H73C71.8954 49 71 48.1046 71 47V35C71 33.8954 71.8954 33 73 33H76C77.1046 33 78 33.8954 78 35V47C78 48.1046 77.1046 49 76 49H75.3347V52.4984H73.3347V49Z",
    fill: "#4281AF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.7544 53.9977C77.7544 54.55 77.3067 54.9977 76.7544 54.9977H71.7544C71.2021 54.9977 70.7544 54.55 70.7544 53.9977C70.7544 53.4454 71.2021 52.9977 71.7544 52.9977H76.7544C77.3067 52.9977 77.7544 53.4454 77.7544 53.9977Z",
    fill: "#4281AF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 54C15 53.4477 15.4477 53 16 53H27C27.5523 53 28 53.4477 28 54C28 54.5523 27.5523 55 27 55H16C15.4477 55 15 54.5523 15 54Z",
    fill: "#4281AF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.8303 31.9971H55.8303V29.9971H58.8303V31.9971ZM53.8303 32H14.8293C14.4175 30.8348 13.3062 30 12 30C10.3431 30 9 31.3431 9 33V47C9 48.6569 10.3431 50 12 50C13.3062 50 14.4175 49.1652 14.8293 48H18V52H25V48H64.1707C64.5825 49.1652 65.6938 50 67 50C68.6569 50 70 48.6569 70 47V33C70 31.3431 68.6569 30 67 30C65.6938 30 64.5825 30.8348 64.1707 32H60.8303V27.9971H53.8303V32ZM12 48C12.5523 48 13 47.5523 13 47V33C13 32.4477 12.5523 32 12 32C11.4477 32 11 32.4477 11 33V47C11 47.5523 11.4477 48 12 48ZM25 46H18H15V34H64V46H25ZM20 50V48H23V50H20ZM66 33V47C66 47.5523 66.4477 48 67 48C67.5523 48 68 47.5523 68 47V33C68 32.4477 67.5523 32 67 32C66.4477 32 66 32.4477 66 33Z",
    fill: "#4281AF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64 26C64 26.5523 63.5523 27 63 27L52 27C51.4477 27 51 26.5523 51 26C51 25.4477 51.4477 25 52 25L63 25C63.5523 25 64 25.4477 64 26Z",
    fill: "#4281AF"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHeatExchanger, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/heatExchanger.6698f50d.svg";
export { ForwardRef as ReactComponent };